<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-data-iterator
            :items="items"
            hide-default-footer>
        <template v-slot:item="props">
            <v-row>
                <v-col :cols="12">
                    <v-card>
                        <v-container>
                            <v-row justify="center" class="mt-1">
                                <a v-if="resultData.errCode != null && resultData.errCode > 0" href="https://reflexapp.io/faq/">Analysis Failed - See FAQs for Tips</a>
                            </v-row>
                        </v-container>
                        <v-list dense>
                            <template v-if="resultData.errCode != null && 0 === resultData.errCode">
                                <v-list-item v-if="'PLR' === resultData.operationalMode">
                                    <v-list-item-content>Eye Location:</v-list-item-content>
                                    <v-list-item-content>{{ props.item.eyeLocation }}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Result Type:</v-list-item-content>
                                    <v-list-item-content>{{ props.item.resultType }}</v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>Baseline Test:</v-list-item-content>
                                    <v-list-item-content>{{ props.item.baseline }}</v-list-item-content>
                                </v-list-item>
                            </template>
                            <template v-else>
                                <v-list-item>
                                    <v-list-item-content>Eye Location:</v-list-item-content>
                                    <v-list-item-content>{{ props.item.eyeLocation }}</v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                        <template v-if="resultData.errCode != null && 0 === resultData.errCode">
                            <template v-if="'PLR' === resultData.operationalMode">
                                <v-card-title>
                                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Analysis</span>
                                </v-card-title>
                                <span v-if="currentUser && currentUser.isProUser && resultData.anisocoria > 2 && (resultData.miosis || (resultDataOtherEye && resultDataOtherEye.miosis))" class="subtitle-1" align="center" style="color:#E53935;width:100%;display:block;">*** Neurological Injury Suspected ***</span>
                                <v-list dense>
                                    <v-list-item v-if="props.item.reflexScore || ('No' === props.item.baseline && resultData.resultTypeIndex !== 3)">
                                        <v-list-item-content>{{ props.item.reflexScore !== '' ? 'Reflex Score:' : '' }}</v-list-item-content>
                                        <v-list-item-content class="mr-2 d-flex flex-row-reverse">{{ props.item.reflexScore }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.concussionCdsScore != null">
                                        <v-list-item-content>Neuro CDS Score:</v-list-item-content>
                                        <v-list-item-content class="d-flex flex-row-reverse" :style="{ backgroundImage: createBackgroundGradient }"><span class="mr-2 d-flex flex-row-reverse">{{ props.item.concussionCdsScore.split(' ')[0] }}</span></v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </template>
                            <template v-if="currentUser && currentUser.isProUser">
                                <v-card-title>
                                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Detection</span>
                                </v-card-title>
                                <v-list dense v-if="'PLR' === resultData.operationalMode">
                                    <v-list-item>
                                        <v-list-item-content :style="{color: props.item.alphaOmega !== '' ? '#E53935' : '#000000'}">{{ props.item.alphaOmega !== '' ? 'Alpha Omega Detected:' : 'Alpha Omega Not Detected' }}</v-list-item-content>
                                        <v-list-item-content>{{ props.item.alphaOmega }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content :style="{color: props.item.anisocoria !== '' ? '#E53935' : '#000000'}">{{ props.item.anisocoria !== '' ? 'Anisocoria Detected:' : 'Anisocoria Not Detected' }}</v-list-item-content>
                                        <v-list-item-content>{{ props.item.anisocoria }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content :style="{color: props.item.miosis !== '' ? '#E53935' : '#000000'}">{{ props.item.miosis !== '' ? 'Miosis Detected:' : 'Miosis Not Detected' }}</v-list-item-content>
                                        <v-list-item-content>{{ props.item.miosis }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content :style="{color: props.item.mydriasis !== '' ? '#E53935' : '#000000'}">{{ props.item.mydriasis !== '' ? 'Mydriasis Detected:' : 'Mydriasis Not Detected' }}</v-list-item-content>
                                        <v-list-item-content>{{ props.item.mydriasis }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content :style="{color: props.item.tonicPupil !== '' ? '#E53935' : '#000000'}">{{ props.item.tonicPupil !== '' ? 'Tonic Pupil Detected' : 'Tonic Pupil Not Detected' }}</v-list-item-content>
                                        <v-list-item-content>{{ props.item.tonicPupil }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list dense v-if="'NPC' === resultData.operationalMode">
                                    <v-list-item>
                                        <v-col md="9">
                                            <v-list-item-content :style="{color: props.item.npcDouble > 7.62 ? '#E53935' : '#000000'}">{{ props.item.npcDouble > 7.62 ? 'Convergence Insufficiency Detected' : 'Convergence Insufficiency Not Detected' }}</v-list-item-content>
                                        </v-col>
                                        <v-col md="3">
                                            <v-list-item-content>{{ props.item.npc }}</v-list-item-content>
                                        </v-col>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-col md="9">
                                            <v-list-item-content>{{ 'CRP' }}</v-list-item-content>
                                        </v-col>
                                        <v-col md="3">
                                            <v-list-item-content>{{ props.item.crp }}</v-list-item-content>
                                        </v-col>
                                    </v-list-item>
                                </v-list>
                            </template>
                            <template v-if="'PLR' === resultData.operationalMode">
                                <v-card-title>
                                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Constrict Results</span>
                                </v-card-title>
                                <span class="subtitle-1" align="center" style="color:#E53935;width:100%;display:block;">(Red values indicate outside normative range)</span>
                                <v-list dense>
                                    <v-list-item v-if="props.item.avgConSpd && preferences.avgConSpd">
                                        <v-list-item-content>Average Constriction Speed:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(0, props.item.avgConSpd) ? '#E53935' : '#000000'}">{{ props.item.avgConSpd }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.timeToMnDiamtr && preferences.timeToMnDiamtr">
                                        <v-list-item-content>Constriction Time:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(3, props.item.timeToMnDiamtr) ? '#E53935' : '#000000'}">{{ props.item.timeToMnDiamtr }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.mxConSpd && preferences.mxConSpd">
                                        <v-list-item-content>Maximum Constriction Speed:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(5, props.item.mxConSpd) ? '#E53935' : '#000000'}">{{ props.item.mxConSpd }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-card-title>
                                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Dilation Results</span>
                                </v-card-title>
                                <span class="subtitle-1" align="center" style="color:#E53935;width:100%;display:block;">(Red values indicate outside normative range)</span>
                                <v-list dense>
                                    <v-list-item v-if="props.item.dilationVel && preferences.dilationVel">
                                        <v-list-item-content>Average Dilation Speed:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(2, props.item.dilationVel) ? '#E53935' : '#000000'}">{{ props.item.dilationVel }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.ramp && preferences.ramp">
                                        <v-list-item-content>Release Amplitude:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(11, props.item.ramp) ? '#E53935' : '#000000'}">{{ props.item.ramp }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.recTime75 && preferences.recTime75">
                                        <v-list-item-content>75% Recover Time:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(9, props.item.recTime75) ? '#E53935' : '#000000'}">{{ props.item.recTime75 }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-card-title>
                                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Other Results</span>
                                </v-card-title>
                                <span class="subtitle-1" align="center" style="color:#E53935;width:100%;display:block;">(Red values indicate outside normative range)</span>
                                <v-list dense>
                                    <v-list-item v-if="props.item.amp && preferences.amp">
                                        <v-list-item-content>Amplitude:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(10, props.item.amp) ? '#E53935' : '#000000'}">{{ props.item.amp }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.avgDiamtr && preferences.avgDiamtr">
                                        <v-list-item-content>Average Diameter:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(1, props.item.avgDiamtr) ? '#E53935' : '#000000'}">{{ props.item.avgDiamtr }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.latncy && preferences.latncy">
                                        <v-list-item-content>Latency:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(4, props.item.latncy) ? '#E53935' : '#000000'}">{{ props.item.latncy }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.mxDiamtr && preferences.mxDiamtr">
                                        <v-list-item-content>Maximum Diameter:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(6, props.item.mxDiamtr) ? '#E53935' : '#000000'}">{{ props.item.mxDiamtr }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.mnDiamtr && preferences.mnDiamtr">
                                        <v-list-item-content>Minimum Diameter:</v-list-item-content>
                                        <v-list-item-content :style="{color: !inRange(7, props.item.mnDiamtr) ? '#E53935' : '#000000'}">{{ props.item.mnDiamtr }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-card-title>
                                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Normative Data Ranges</span>
                                </v-card-title>
                                <span class="subtitle-1" align="center" style="color:#000000;width:100%;display:block;">(Values based on test type, patient age, and pulse brightness level)</span>
                                <v-list dense>
                                    <v-list-item v-if="props.item.amp && preferences.amp">
                                        <v-list-item-content>Amplitude:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(10)} ${getMinMaxNormRangeForParam(10) !== 'N/A' ? 'mm' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.avgConSpd && preferences.avgConSpd">
                                        <v-list-item-content>Average Constriction Speed:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(0)} ${getMinMaxNormRangeForParam(0) !== 'N/A' ? 'mm/sec' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.dilationVel && preferences.dilationVel">
                                        <v-list-item-content>Average Dilation Speed:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(2)} ${getMinMaxNormRangeForParam(2) !== 'N/A' ? 'mm/sec' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.avgDiamtr && preferences.avgDiamtr">
                                        <v-list-item-content>Average Diameter:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(1)} ${getMinMaxNormRangeForParam(1) !== 'N/A' ? 'mm' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.timeToMnDiamtr && preferences.timeToMnDiamtr">
                                        <v-list-item-content>Constriction Time:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(3)} ${getMinMaxNormRangeForParam(3) !== 'N/A' ? 'sec' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.latncy && preferences.latncy">
                                        <v-list-item-content>Latency:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(4)} ${getMinMaxNormRangeForParam(4) !== 'N/A' ? 'sec' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.mxConSpd && preferences.mxConSpd">
                                        <v-list-item-content>Maximum Constriction Speed:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(5)} ${getMinMaxNormRangeForParam(5) !== 'N/A' ? 'mm/sec' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.mxDiamtr && preferences.mxDiamtr">
                                        <v-list-item-content>Maximum Diameter:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(6)} ${getMinMaxNormRangeForParam(6) !== 'N/A' ? 'mm' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.mnDiamtr && preferences.mnDiamtr">
                                        <v-list-item-content>Minimum Diameter:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(7)} ${getMinMaxNormRangeForParam(7) !== 'N/A' ? 'mm' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.ramp && preferences.ramp">
                                        <v-list-item-content>Release Amplitude:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(11)} ${getMinMaxNormRangeForParam(11) !== 'N/A' ? 'mm' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="props.item.recTime75 && preferences.recTime75">
                                        <v-list-item-content>75% Recover Time:</v-list-item-content>
                                        <v-list-item-content style="color:#000000">{{ `${getMinMaxNormRangeForParam(9)} ${getMinMaxNormRangeForParam(9) !== 'N/A' ? 'sec' : ''}` }}</v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </template>
                        </template>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </v-data-iterator>
</template>

<script>
    import {mapActions, mapMutations, mapState} from 'vuex';
    import { formatNumber, returnAge, returnTorchLevelIndex } from '@/store/tests';

    export default
    {
        name: 'test-result-data',
        data: function ()
        {
            return {
                items: [{}],
                preferences: {}
            }
        },
        props:
        {
            tab: null,
            patientDob: null,
            resultData: {},
            resultDataOtherEye: null
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            }),
            ...mapState('tests',
            {
                normalizedData: state => state.normalizedData
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            }),
            createBackgroundGradient()
            {
                return `linear-gradient(to right, ${'#FFFFFF'}, ${this.resultData.concussionCdsColor})`;
            }
        },
        watch:
        {
            resultData()
            {
                this.resultDataCommon()
            }
        },
        async mounted()
        {
            await this.loadNormalizedData();
            this.resultDataCommon()
        },
        methods:
        {
            ...mapActions('tests', ['GET_NORMALIZED_DATA']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            resultDataCommon: function()
            {
                this.items = [{}];
                this.items[0].eyeLocation = this.resultData.eyeLocation;
                this.items[0].resultTypeIndex = this.resultData.resultTypeIndex;
                this.items[0].resultType = this.resultData.resultType;
                this.items[0].baseline = this.resultData.baseline;
                if ('PLR' === this.resultData.operationalMode)
                {
                    this.preferences = this.getPreferencesForMetaData(this.resultData.resultTypeIndex);
                    if (this.resultData.reflexScore && this.resultData.resultTypeIndex !== 3)
                    {
                        this.items[0].reflexScore = this.resultData.reflexScore
                    }
                    else
                    {
                        this.items[0].reflexScore = 'N/A'
                    }
                    this.items[0].concussionCdsScore = this.resultData.concussionCdsScore;
                    this.items[0].calculationMethod = this.resultData.metaData.calculationMethod;
                    // Only show this data if the user is at Pro level
                    if (this.currentUser.isProUser)
                    {
                        this.items[0].alphaOmega = this.resultData.alphaOmega ? `${this.resultData.alphaOmega}+ AO` : '';
                        const corectasia = this.resultData.corectasia ? `(${this.resultData.corectasia} Larger)` : '';
                        this.items[0].anisocoria = this.resultData.anisocoria ? `${this.resultData.anisocoria} mm diff. ${corectasia}` : '';
                        this.items[0].miosis = this.resultData.miosis ? `${this.resultData.miosis} mm` : '';
                        this.items[0].mydriasis = this.resultData.mydriasis ? `${this.resultData.mydriasis} mm` : '';
                        this.items[0].tonicPupil = this.resultData.tonicPupil ? this.resultData.tonicPupil : ''
                    }

                    if (this.preferences.amp)
                    {
                        if (this.resultData.amp)
                        {
                            this.items[0].amp = `${this.resultData.amp} mm`
                        }
                        else
                        {
                            this.items[0].amp = 'N/A'
                        }
                    }
                    if (this.preferences.avgConSpd)
                    {
                        if (this.resultData.avgConSpd)
                        {
                            this.items[0].avgConSpd = `${this.resultData.avgConSpd} mm/sec`
                        }
                        else
                        {
                            this.items[0].avgConSpd = 'N/A'
                        }
                    }
                    if (this.preferences.avgDiamtr)
                    {
                        if (this.resultData.avgDiamtr)
                        {
                            this.items[0].avgDiamtr = `${this.resultData.avgDiamtr} mm`
                        }
                        else
                        {
                            this.items[0].avgDiamtr = 'N/A'
                        }
                    }
                    if (this.preferences.dilationVel)
                    {
                        if (this.resultData.dilationVel)
                        {
                            this.items[0].dilationVel = `${this.resultData.dilationVel} mm/sec`
                        }
                        else
                        {
                            this.items[0].dilationVel = 'N/A'
                        }
                    }
                    if (this.preferences.timeToMnDiamtr)
                    {
                        if (this.resultData.timeToMnDiamtr)
                        {
                            this.items[0].timeToMnDiamtr = `${this.resultData.timeToMnDiamtr} sec`
                        }
                        else
                        {
                            this.items[0].timeToMnDiamtr = 'N/A'
                        }
                    }
                    if (this.preferences.latncy)
                    {
                        if (this.resultData.latncy)
                        {
                            this.items[0].latncy = `${this.resultData.latncy} sec`
                        }
                        else
                        {
                            this.items[0].latncy = 'N/A'
                        }
                    }
                    if (this.preferences.mxConSpd)
                    {
                        if (this.resultData.mxConSpd)
                        {
                            this.items[0].mxConSpd = `${this.resultData.mxConSpd} mm/sec`
                        }
                        else
                        {
                            this.items[0].mxConSpd = 'N/A'
                        }
                    }
                    if (this.preferences.mxDiamtr)
                    {
                        if (this.resultData.mxDiamtr)
                        {
                            this.items[0].mxDiamtr = `${this.resultData.mxDiamtr} mm`
                        }
                        else
                        {
                            this.items[0].mxDiamtr = 'N/A'
                        }
                    }
                    if (this.preferences.mnDiamtr)
                    {
                        if (this.resultData.mnDiamtr)
                        {
                            this.items[0].mnDiamtr = `${this.resultData.mnDiamtr} mm`
                        }
                        else
                        {
                            this.items[0].mnDiamtr = 'N/A'
                        }
                    }
                    if (this.preferences.ramp)
                    {
                        if (this.resultData.ramp)
                        {
                            this.items[0].ramp = `${this.resultData.ramp} mm`
                        }
                        else
                        {
                            this.items[0].ramp = 'N/A'
                        }
                    }
                    if (this.preferences.recTime75)
                    {
                        if (this.resultData.recTime75)
                        {
                            this.items[0].recTime75 = `${this.resultData.recTime75} sec`
                        }
                        else
                        {
                            this.items[0].recTime75 = 'N/A'
                        }
                    }
                }
                else // NPC
                {
                    // Only show this data if the user is at Pro level
                    if (this.currentUser.isProUser)
                    {
                        this.items[0].npcDouble = this.resultData.npc;
                        if ('STANDARD' === this.currentUser.preferences.unitsOfMeasure)
                        {
                            // Convert from cm to in
                            this.resultData.npc = this.resultData.npc ? formatNumber(this.resultData.npc / 2.54, 2) : null;
                            this.resultData.crp = this.resultData.crp ? formatNumber(this.resultData.crp / 2.54, 2) : null
                        }
                        else
                        {
                            this.resultData.npc = this.resultData.npc ? formatNumber(this.resultData.npc, 2) : null;
                            this.resultData.crp = this.resultData.crp ? formatNumber(this.resultData.crp, 2) : null
                        }
                        this.items[0].npc = `${this.resultData.npc} ${'STANDARD' === this.currentUser.preferences.unitsOfMeasure ? 'in' : 'cm'}`;
                        this.items[0].crp = this.resultData.crp ? `${this.resultData.crp} ${'STANDARD' === this.currentUser.preferences.unitsOfMeasure ? 'in' : 'cm'}` : 'N/A'
                    }
                }
            },
            getPreferencesForMetaData(resultTypeIndex)
            {
                // If No light
                if (3 === resultTypeIndex)
                {
                    return {
                        amp: this.currentUser.preferences.ampA,
                        avgConSpd: false,
                        avgDiamtr: this.currentUser.preferences.avgDiamtrA,
                        dilationVel: false,
                        timeToMnDiamtr: false,
                        latncy: false,
                        mxConSpd: false,
                        mxDiamtr: this.currentUser.preferences.mxDiamtrA,
                        mnDiamtr: this.currentUser.preferences.mnDiamtrA,
                        ramp: this.currentUser.preferences.rampA,
                        recTime75: false
                    }
                }
                // If full spectrum
                if (resultTypeIndex !== 0)
                {
                    return {
                        amp: this.currentUser.preferences.ampB,
                        avgConSpd: this.currentUser.preferences.avgConSpdB,
                        avgDiamtr: this.currentUser.preferences.avgDiamtrB,
                        dilationVel: this.currentUser.preferences.dilationVelB,
                        timeToMnDiamtr: this.currentUser.preferences.timeToMnDiamtrB,
                        latncy: this.currentUser.preferences.latncyB,
                        mxConSpd: this.currentUser.preferences.mxConSpdB,
                        mxDiamtr: this.currentUser.preferences.mxDiamtrB,
                        mnDiamtr: this.currentUser.preferences.mnDiamtrB,
                        ramp: this.currentUser.preferences.rampB,
                        recTime75: this.currentUser.preferences.recTime75B
                    }
                }
                // Else constrict
                return {
                    amp: this.currentUser.preferences.ampC,
                    avgConSpd: this.currentUser.preferences.avgConSpdC,
                    avgDiamtr: this.currentUser.preferences.avgDiamtrC,
                    dilationVel: false,
                    timeToMnDiamtr: this.currentUser.preferences.timeToMnDiamtrC,
                    latncy: this.currentUser.preferences.latncyC,
                    mxConSpd: this.currentUser.preferences.mxConSpdC,
                    mxDiamtr: this.currentUser.preferences.mxDiamtrC,
                    mnDiamtr: this.currentUser.preferences.mnDiamtrC,
                    ramp: this.currentUser.preferences.rampC,
                    recTime75: false
                }
            },
            async loadNormalizedData()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_NORMALIZED_DATA()
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            getMinMaxNormRangeForParam(parameterIndex)
            {
                if (!this.normalizedData)
                {
                    return {minNormalData: 0, maxNormalData: 0}
                }
                const torchLevelIndex = returnTorchLevelIndex(this.items[0].resultTypeIndex, this.resultData.metaData.torchLevel);
                const normalizedDataMinMax = this.normalizedData.data[`parameter${parameterIndex}`][this.items[0].resultTypeIndex][returnAge(this.patientDob, this.resultData.visitDate)][torchLevelIndex];
                if (0 === normalizedDataMinMax.minNormalData || 100 === normalizedDataMinMax.maxNormalData)
                {
                    return 'N/A'
                }
                return `${formatNumber(normalizedDataMinMax.minNormalData)} - ${formatNumber(normalizedDataMinMax.maxNormalData)}`
            },
            inRange(parameterIndex, value)
            {
                if ('N/A' === value || !this.normalizedData)
                {
                    return true
                }
                // Remove the unit of measure
                const valueOnly = value.split(' ')[0];
                const torchLevelIndex = returnTorchLevelIndex(this.items[0].resultTypeIndex, this.resultData.metaData.torchLevel);
                const normalizedDataMinMax = this.normalizedData.data[`parameter${parameterIndex}`][this.items[0].resultTypeIndex][returnAge(this.patientDob, this.resultData.visitDate)][torchLevelIndex];
                return valueOnly >= normalizedDataMinMax.minNormalData && valueOnly <= normalizedDataMinMax.maxNormalData
            }
        }
    };
</script>

<style scoped>
</style>